import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const fixImg = (url) => !url ? null : (url.startsWith('http') ? url : `${BACKEND}${url}`);

/**
 * CAROUSEL — horizontally-scrollable track with arrow controls. Each slide is a
 * card with cover image + title. Uses native scroll-snap (no external lib).
 */
export default function CarouselBlock({ category, articles }) {
  const color = category?.color || '#dc2626';
  const trackRef = useRef(null);
  if (!articles?.length) return null;
  const scroll = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    const amount = el.clientWidth * 0.8 * (dir === 'next' ? 1 : -1);
    el.scrollBy({ left: amount, behavior: 'smooth' });
  };

  return (
    <div className="relative" data-testid="carousel-block">
      <div ref={trackRef} data-testid="carousel-track"
           className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {articles.slice(0, 8).map((a, i) => (
          <Link key={a.id} to={`/clanak/${a.slug}`} data-testid={`carousel-slide-${i}`}
                className="group shrink-0 snap-start w-[260px] sm:w-[300px] rounded-xl overflow-hidden bg-white dark:deep-black-card border border-transparent dark:border-white/5">
            <div className="aspect-[4/3] bg-gray-100 dark:bg-black/40 overflow-hidden">
              {fixImg(a.cover_image_url) && (
                <img src={fixImg(a.cover_image_url)} alt={a.title_hr} loading="lazy"
                     className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              )}
            </div>
            <div className="p-3.5">
              <span className="inline-block text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-sm mb-2"
                    style={{ backgroundColor: color }}>{category.name_hr}</span>
              <h3 className="text-[14px] font-bold leading-snug text-gray-900 dark:text-gray-50 group-hover:text-red-600 dark:group-hover:text-red-400 line-clamp-3 transition-colors">
                {a.title_hr}
              </h3>
            </div>
          </Link>
        ))}
      </div>
      <button onClick={() => scroll('prev')} data-testid="carousel-prev"
              aria-label="Prethodno"
              className="hidden md:grid place-items-center absolute top-1/2 -left-3 -translate-y-1/2 w-10 h-10 rounded-full bg-white dark:deep-black-card shadow-lg ring-1 ring-gray-200 dark:ring-white/10 hover:bg-red-600 hover:text-white transition-colors">
        <ChevronLeft size={18} />
      </button>
      <button onClick={() => scroll('next')} data-testid="carousel-next"
              aria-label="Sljedeće"
              className="hidden md:grid place-items-center absolute top-1/2 -right-3 -translate-y-1/2 w-10 h-10 rounded-full bg-white dark:deep-black-card shadow-lg ring-1 ring-gray-200 dark:ring-white/10 hover:bg-red-600 hover:text-white transition-colors">
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
